module.exports = __webpack_public_path__ + "img/order_now_btn.a11c576f.png";